const getFormattedDate = (seconds) => {
    const date = new Date(seconds * 1000); // Convert seconds to milliseconds
  
    const day = date.getDate();           // Get day (1-31)
    const month = date.getMonth() + 1;    // Get month (0-11, so we add 1)
    const year = date.getFullYear();      // Get 4-digit year
  
    return `${month}/${day}/${year}`;
  };
  
  export default getFormattedDate;
  